import { ProviderTemplate } from './types';
import { cloudProviders } from './cloudProviders';
import { domainProviders } from './domainProviders';
import { infrastructureProviders } from './infrastructureProviders';

export * from './types';
export { cloudProviders } from './cloudProviders';
export { domainProviders } from './domainProviders';
export { infrastructureProviders } from './infrastructureProviders';

export const providerTemplates: Record<string, ProviderTemplate> = {
  ...infrastructureProviders,
  ...cloudProviders,
  ...domainProviders,
};

// Helper functions
export const getProvidersByCategory = () => ({
  infrastructure: infrastructureProviders,
  cloud: cloudProviders,
  domains: domainProviders,
});

export const getProviderTemplate = (providerId: string): ProviderTemplate | undefined => {
  return providerTemplates[providerId];
};

export const getAllProviderIds = (): string[] => {
  return Object.keys(providerTemplates);
};

export const getProvidersByType = (type: 'infrastructure' | 'cloud' | 'domains') => {
  switch (type) {
    case 'infrastructure':
      return infrastructureProviders;
    case 'cloud':
      return cloudProviders;
    case 'domains':
      return domainProviders;
    default:
      return {};
  }
};